if(!customElements.get('header-extend-new')) {
  customElements.define('header-extend-new', class extends HTMLElement {
    constructor() {
      super();
      this.isMegaMenuOpen = false;
      this.megaMenuTimer = null;
      this.menuLinks = this.querySelectorAll('li.menu-link');
      this.header = this.querySelector('header.y1-header');
    }

    connectedCallback() {
      this.menuLinks.forEach(link => {
        if (link.hasAttribute('data-mega-menu')) {
          link.addEventListener('mouseenter', this.handleLinkMouseEnter.bind(this));
          link.addEventListener('mouseleave', this.handleLinkMouseLeave.bind(this));
        }
      });
    }

    handleLinkMouseEnter(event) {
      const link = event.currentTarget;
      this.isMegaMenuOpen = true;
      this.header.classList.toggle('mega-menu-open', this.isMegaMenuOpen);
    }

    handleLinkMouseLeave(event) {
      const link = event.currentTarget;
      this.isMegaMenuOpen = false;
      setTimeout(() => {
        this.header.classList.toggle('mega-menu-open', this.isMegaMenuOpen);
      }, 200);
    }
  });
}